import PropTypes from "prop-types"
import { omit } from "lodash"
import moment from "moment"
import { PickersDay } from "@mui/x-date-pickers"

export default function DateRangePickerDay(props) {
  let className
  const { day, startDate, endDate } = props
  if (day.isBetween(startDate, endDate)) {
    className = "components_date-range-picker_between"
  } else if (day.isSame(startDate)) {
    className = "components_date-range-picker_start"
  } else if (day.isSame(endDate)) {
    className = "components_date-range-picker_end"
  }
  return <PickersDay {...omit(props, ["startDate", "endDate"])} className={className} />
}

DateRangePickerDay.propTypes = {
  day: PropTypes.instanceOf(moment).isRequired,
  startDate: PropTypes.instanceOf(moment).isRequired,
  endDate: PropTypes.instanceOf(moment).isRequired,
}
